import { useQueryClient } from '@tanstack/react-query';
import { eventQueryKeys, useAuthStore, useLiveEvents } from '@wordpuppi/shared';
import { toast } from 'sonner';
import { useBaxterEffects } from '@/lib/baxterEffects';
import { applyToolEffects } from '@/lib/mediaEffects';

export function LiveEventsBridge() {
  const token = useAuthStore((state) => state.token);
  const queryClient = useQueryClient();
  useLiveEvents({ token, onEvent: (event) => {
    if (event.toast) toast[event.toast.level](event.toast.text);
    if (event.site_slug && useBaxterEffects.getState().noticeSiteSlug === event.site_slug) {
      void applyToolEffects(queryClient, event.site_slug,
        { name: 'live_event', args: { site_slug: event.site_slug } }, { ok: true, event });
    } else {
      for (const queryKey of eventQueryKeys(event)) void queryClient.invalidateQueries({ queryKey }, { cancelRefetch: false });
    }
  } });
  return null;
}
